import { Loader } from "@mantine/core";
import { Modal } from "@mantine/core";
import { AiFillCheckCircle } from "react-icons/ai";
import { MdOutlineCancel } from "react-icons/md";

const ClaimModal = ({ opened, setOpened, claimStatus }) => {
  const finishClaim = () => {
    setOpened(false);
  };
  return claimStatus === "finished" ? (
    <Modal
      opened={opened}
      centered
      onClose={finishClaim}
      withCloseButton={false}
    >
      <MdOutlineCancel
        className="hover: absolute  top-4 right-6 h-6 w-6 text-primary"
        onClick={finishClaim}
      />
      <div
        className="flex flex-col items-center justify-center"
        data-testid="claim-success-modal"
      >
        <img
          src={"/airdrop_assets/confirmpage_check.png"}
          alt="checkmark"
          className="mt-10 mb-7 w-16"
        />
        <div className="mb-3 text-center text-base font-bold text-primary">
          Claim Successful
        </div>
        <div className="mb-9 text-sm text-gray1">
          You can view your airdrop in your wallet
        </div>
        <button className="btn-pri mb-12 px-16" onClick={finishClaim}>
          Close
        </button>
      </div>
    </Modal>
  ) : (
    <Modal
      opened={opened}
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center">
          <div className="mb-4 mt-6">
            {claimStatus === "claiming" ? (
              <Loader color={"#ADB5FF"} size={50} />
            ) : (
              <AiFillCheckCircle color="#ADB5FF" size="50px" />
            )}
          </div>

          <div className="flex flex-col items-center justify-center text-white">
            <div className="mb-3 text-center text-base font-bold text-primary">
              Claim Your Airdrop
            </div>
            <div className="mb-5 text-center text-sm text-gray1">
              <div>Please wait while we claim your airdrop</div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ClaimModal;
